import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";

export const TodayPaymentLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.first_payment) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={preview.first_payment.due_on_phrase}
      value={preview.first_payment.formatted_amount_due}
      labelWeight="semibold"
      valueWeight="semibold"
      dataTestId="checkout-form-preview-today-payment-total"
      {...options}
    />
  );
};
